// Derives the redirect path prefix for the payment flow from the current
// pathname, preserving the campaign slug when the user is on a slug-aware route
// (`/sostienici/{slug}` or `/lnd/{slug}`). Reserved flow segments (confirm/successo/
// errore) are never treated as a slug, so the legacy `/sostienici/successo` style
// routes keep falling back to the base prefix.

import {
  DONATION_PATH_ROOT,
  DONATION_PATH_SEGMENT,
  LEGACY_DONATION_PATH_SEGMENT,
  LND_PATH_SEGMENT,
} from '@/utils/donationPaths'

const RESERVED_SEGMENTS = new Set(['confirm', 'successo', 'errore'])

/**
 * @param {string} pathname e.g. '/sostienici/natale-2026/confirm'
 * @returns {string} path prefix e.g. '/sostienici/natale-2026'
 */
export function derivePathPrefix(pathname) {
  if (typeof pathname !== 'string' || pathname.length === 0) {
    return DONATION_PATH_ROOT
  }

  const segments = pathname.split('/').filter(Boolean)
  const root = segments[0]
  const base =
    root === LND_PATH_SEGMENT
      ? LND_PATH_SEGMENT
      : root === LEGACY_DONATION_PATH_SEGMENT
        ? DONATION_PATH_SEGMENT
        : root === DONATION_PATH_SEGMENT
          ? DONATION_PATH_SEGMENT
          : DONATION_PATH_SEGMENT
  const maybeSlug = segments[1]

  if (maybeSlug && !RESERVED_SEGMENTS.has(maybeSlug)) {
    return `/${base}/${maybeSlug}`
  }

  return `/${base}`
}

export default derivePathPrefix
